// glode-testata-init.js — il comportamento della testata del prototipo (P35, 10/09/2026): la
// parte «testata» di montaMega() e montaTelaio() in glode-premium.js:266-336, senza piede né
// cassetto finto. I pannelli si aprono al passaggio del mouse sulle voci con data-mega, si
// chiudono al click su un link, fuori dalla testata, con Esc, e quando il mouse esce; l'hamburger
// apre e chiude il menu mobile.
//
// «Carrello (n)» è il cassetto di Horizon: il contatore parte da /cart.js e segue lo stesso evento
// che aggiorna l'icona di Horizon (StandardEvents.cartLinesUpdate, cart-icon.js:31, modulo
// «@shopify/events» dell'import map); il click apre #cart-drawer con theme-drawer.open()
// (cart-drawer.js:81 e :94). Se il modulo o il cassetto mancassero, il link porta a /cart.
//
// I pannelli a schede usano `tile` e `ordinaPerEsigenza` di glode-premium.js e l'elenco completo
// dei prodotti letto qui con fetch da glode-prodotti-data.js e valutato in una funzione (quel file
// dichiara una const globale e la pagina lo carica anche lei): sulla scheda prodotto
// window.GLODE_PRODOTTI contiene solo il prodotto e i correlati. glode-premium.js arriva in fondo
// alla pagina dalle sezioni; dove nessuna lo carica (il catalogo) lo aggiunge questo script.
//
// Le variabili --header-height e --header-group-height le scrive qui, perché il layout di Horizon
// le calcola solo se trova header-component (layout/theme.liquid:55-59).
(function () {
  const header = document.getElementById('glode-testata');
  if (!header) return;
  const toggles = [...header.querySelectorAll('.nav-shop[data-mega]')];
  const ham = header.querySelector('.hamburger');
  const menuM = header.querySelector('.menu-mobile');

  function chiudiTutti() {
    header.querySelectorAll('.mega').forEach(m => { m.hidden = true; });
    toggles.forEach(t => t.classList.remove('aperto'));
    if (menuM) menuM.hidden = true;
    if (ham) { ham.classList.remove('aperto'); ham.setAttribute('aria-expanded', 'false'); }
  }
  if (ham && menuM) ham.addEventListener('click', () => {
    const apri = menuM.hidden;
    chiudiTutti();
    if (apri) { menuM.hidden = false; ham.classList.add('aperto'); ham.setAttribute('aria-expanded', 'true'); }
  });
  // le voci sono VERI LINK: il click naviga, il pannello si apre al passaggio del mouse
  // (segnalazioni cliente 07/08 e 18/08: i prodotti restano raggiungibili anche senza pannello)
  toggles.forEach(t => t.addEventListener('mouseenter', () => {
    const panel = document.getElementById(t.dataset.mega);
    if (!panel) return;
    chiudiTutti();
    panel.hidden = false;
    t.classList.add('aperto');
  }));
  header.addEventListener('mouseleave', chiudiTutti);
  document.addEventListener('click', e => { if (!e.target.closest('#glode-testata')) chiudiTutti(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') chiudiTutti(); });
  header.addEventListener('click', e => { if (e.target.closest('a[href]') && !e.target.closest('.cart-link')) chiudiTutti(); });

  // ---- pannelli a schede: famiglie ed esigenze, dal menu e dal dato prodotti ----
  let MENU = [];
  try { MENU = JSON.parse(document.getElementById('glode-dati-menu').textContent); }
  catch (e) { console.error('[glode] il menu non è JSON valido: pannelli a schede vuoti', e); }
  // l'elenco completo dei prodotti, valutato in una funzione: glode-prodotti-data.js dichiara una
  // const globale e la pagina lo carica anche lei; due dichiarazioni sarebbero un errore di sintassi
  let PRODOTTI = [];
  const datiPronti = window.__glodeDatiProdottiUrl
    ? fetch(window.__glodeDatiProdottiUrl).then(r => r.text()).then(src => { const finestra = {}; new Function('window', src)(finestra); PRODOTTI = finestra.GLODE_PRODOTTI || []; }).catch(e => console.error('[glode] elenco prodotti per la testata non letto:', e))
    : Promise.resolve();

  function pannelloTab(voce, idTabs, idTiles, prodottiDi) {
    const tabsEl = document.getElementById(idTabs);
    const tilesEl = document.getElementById(idTiles);
    if (!tabsEl || !tilesEl || !voce.sotto.length) return;
    let attiva = voce.sotto[0];
    function render() {
      tabsEl.innerHTML = voce.sotto.map(s =>
        `<button type="button" class="mega-tab${s === attiva ? ' attiva' : ''}" data-v="${s.titolo.replace(/"/g, '&quot;')}">${s.titolo}</button>`).join('');
      const prods = prodottiDi(attiva);
      const scena = typeof MENU_SCENA !== 'undefined' && MENU_SCENA[attiva.titolo] ? MENU_SCENA[attiva.titolo]
        : typeof SCENA_ESIGENZA !== 'undefined' && SCENA_ESIGENZA[attiva.titolo] ? SCENA_ESIGENZA[attiva.titolo] : 'assets/img/hero-linea.png';
      const copertina = attiva.copertina || (typeof __glodeImg === 'function' ? __glodeImg(scena) : scena);
      // Il fuoco per immagine (A-038, «in nutrimento il siero è tagliato», call 27/08): il prototipo lo
      // calcola dal nome del file (premium.js, FUOCO_SCENA) e lo mette come stile inline. Qui la
      // copertina arriva dal CDN di Shopify, che al nome aggiunge un suffisso quando il file esiste già
      // (scena-1-1_796873f5-….jpg): si toglie prima di cercare, altrimenti si cade sul 50% 55% del CSS.
      const nomeScena = (String(copertina).split('?')[0].split('/').pop() || '').replace(/_[0-9a-f]{8}-[0-9a-f-]{27,}(\.[a-z]+)$/i, '$1');
      // P45 (14/09/2026, scelta di Mohamed: «mostriamo tutto il prodotto»): le immagini di collezione sono
      // ora le copertine ricavate dalla foto originale con il rapporto del riquadro (1,607:1 per 612×381,
      // 1,718:1 per 612×356) e il prodotto intero al centro (scripts/shopify/carica-copertine-v3.mjs). Con
      // lo stesso rapporto `cover` non taglia niente e il fuoco non ha più niente da spostare: si centra.
      // FUOCO_SCENA resta per il ripiego sull'asset 2:3 del tema, quando la collezione non ha immagine.
      const fuoco = attiva.copertina ? '50% 50%' : ((typeof FUOCO_SCENA !== 'undefined' && FUOCO_SCENA[nomeScena]) || '50% 55%');
      tilesEl.innerHTML =
        `<a class="mega-scena" href="${attiva.url}"><img src="${copertina}" style="object-position:${fuoco}" alt="${attiva.titolo}"><span>${attiva.titolo} →</span></a>` +
        (prods.length ? prods.slice(0, 2).map(tile).join('') : `<p class="mega-vuoto">In arrivo</p>`);
    }
    function cambia(e) {
      const b = e.target.closest('.mega-tab');
      if (!b) return;
      const s = voce.sotto.find(x => x.titolo === b.dataset.v);
      if (s && s !== attiva) { attiva = s; render(); }
    }
    tabsEl.addEventListener('mouseover', cambia);
    tabsEl.addEventListener('click', cambia);
    render();
  }
  function montaPannelli() {
    for (const v of MENU) {
      if (v.tipo === 'prodotti') pannelloTab(v, 'tabs-prodotti', 'tiles-prodotti', s => PRODOTTI.filter(p => p.famiglia === s.titolo));
      if (v.tipo === 'esigenze') pannelloTab(v, 'tabs-esigenze', 'tiles-esigenze', s => ordinaPerEsigenza(PRODOTTI.filter(p => (p.esigenze || []).includes(s.titolo)), s.titolo));
    }
  }
  function quandoPronto() {
    if (typeof tile === 'function' && typeof ordinaPerEsigenza === 'function') { datiPronti.then(montaPannelli); return; }
    // nessuna sezione ha caricato glode-premium.js (per esempio il catalogo): lo si aggiunge qui
    if (!window.__glodePremiumUrl) return;
    const s = document.createElement('script');
    s.src = window.__glodePremiumUrl;
    s.onload = () => datiPronti.then(montaPannelli);
    s.onerror = () => console.error('[glode] glode-premium.js non caricato: pannelli a schede vuoti');
    document.body.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quandoPronto);
  else quandoPronto();

  // ---- carrello: contatore e apertura del cassetto di Horizon ----
  const contatori = [...header.querySelectorAll('.cart-n')];
  // P46: anche data-carrello sull'header, che nasconde il numero dell'icona del telefono a carrello vuoto
  const aggiorna = n => { contatori.forEach(c => { c.textContent = n; }); header.dataset.carrello = n; };
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => aggiorna(c.item_count)).catch(() => {});
  // ─────────────────────────────────────────────────────────────────────────────────────────

  const dl = (evento, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });   // GA4 impasta gli items senza questo
    window.dataLayer.push({ event: evento, ecommerce });
  };

  // L'id NUMERICO della variante, nella stessa forma del pixel del checkout. Le tre forme che
  // arrivano davvero, lette in https://cdn.shopify.com/storefront/standard-events.js:
  //  · add_to_cart → `merchandiseId` normalizzato a gid dal costruttore di CartLinesUpdateEvent
  //    (`action === 'add'` ⇒ ProductVariant), anche quando il tema passa il numero nudo
  //    (product-form.js:419 passa `formData.get('id')`, glode-quiz-init.js:231 una stringa);
  //  · carrello dall'Ajax → `lines[].id` è la CHIAVE di riga «57426568872316:abc…»
  //    (`createCartFromAjaxResponse` fa `c(t.key)`, e una chiave non è un gid CartLine);
  //  · carrello dal filtro Liquid → `lines[].id` PUÒ essere un gid CartLine, che NON contiene
  //    l'id della variante: in quel caso qui esce '' e si ripiega sul `data-key` della riga.
  const idVariante = (v) => {
    const s = String(v || '');
    const gid = s.match(/^gid:\/\/shopify\/ProductVariant\/(\d+)/);
    if (gid) return gid[1];
    const chiave = s.match(/^(\d+):/);
    if (chiave) return chiave[1];
    return /^\d+$/.test(s) ? s : '';
  };

  // Nome, formato e famiglia: dal JSON della scheda quando c'è (glode-prodotto-dati.liquid rende
  // il prodotto corrente più i suoi cross-sell), altrimenti dalla riga del carrello, che porta il
  // titolo e il valore dell'opzione (cart-products.liquid:240-243). Su /cart il JSON della scheda
  // non c'è — misurato: la pagina non carica glode-prodotti-data.js né #glode-dati-prodotto — quindi
  // lì il formato arriva dalla riga e la FAMIGLIA non arriva da nessuna parte: si omette, non si inventa.
  const schedaDi = (id, riga) => {
    for (const x of (window.GLODE_PRODOTTI || [])) {
      const v = (x.varianti || []).find((v) => String(v.id) === id);
      if (v) return { item_name: x.nome, item_variant: v.formato, item_brand: 'Glodé', item_category: x.famiglia, price: v.prezzo };
      if (String(x.varianteId) === id) return { item_name: x.nome, item_variant: x.formato, item_brand: 'Glodé', item_category: x.famiglia, price: x.prezzo };
    }
    const r = riga || (id && document.querySelector(`[data-key^="${id}:"]`));
    if (!r) return { item_brand: 'Glodé' };
    const fuori = { item_brand: 'Glodé' };
    const t = r.querySelector('.cart-items__title');
    if (t) fuori.item_name = t.textContent.trim();
    const v = r.querySelector('.cart-items__variants dd');
    if (v) fuori.item_variant = v.textContent.replace(/,\s*$/, '').trim();
    return fuori;
  };

  // Le righe del carrello nel DOM, nell'ordine in cui stanno in pagina: servono per gli id quando
  // l'evento porta un gid CartLine, per il formato, e come ultimo ripiego. Si prende il componente
  // giusto — cassetto o pagina carrello — dal `context` dell'evento: `data-drawer` lo mette
  // cart-items-component.liquid:11-13.
  const righeDom = (contesto) => {
    const box = document.querySelector(contesto === 'dialog' ? 'cart-items-component[data-drawer]' : 'cart-items-component:not([data-drawer])')
      || document.querySelector('cart-items-component');
    return box ? [...box.querySelectorAll('[data-key]')].filter((r) => /^\d+:/.test(r.dataset.key || '')) : [];
  };

  // T03b · L'ultimo carrello visto da cartLinesUpdate. È la fotografia più fresca che abbiamo: viene
  // dalla risposta Ajax della modifica, mentre il payload di `shopify:cart:view` lo rende Liquid al
  // CARICO della pagina e resta fermo a com'era il carrello allora.
  let ultimoCarrello = null;

  const unitario = (riga) => {
    const t = Number(riga && riga.cost && riga.cost.totalAmount && riga.cost.totalAmount.amount);
    const q = Number(riga && riga.quantity);
    return q > 0 && Number.isFinite(t) ? t / q : undefined;   // l'importo di riga è il TOTALE
  };

  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, e => {
      if (!e.promise) return;
      e.promise.then(({ cart, detail }) => {
        aggiorna(cart?.totalQuantity ?? detail?.itemCount ?? 0);
        // T03b: si tiene per view_cart, e si tiene per OGNI azione — anche 'remove' e 'update' —
        // così una riga tolta dal cassetto non lascia in memoria un carrello che non esiste più.
        if (cart && Array.isArray(cart.lines)) ultimoCarrello = cart;
        // T02 · add_to_cart: solo le aggiunte. 'remove' e 'update' non hanno un tag nel contenitore.
        if (e.action !== 'add' || !cart) return;
        let valore = 0;
        const items = (e.lines || []).map((l) => {
          const id = idVariante(l.merchandiseId);
          // il prezzo unitario dalla riga del carrello DOPO l'aggiunta: se la variante c'era già
          // il totale di riga copre anche le vecchie unità, ma diviso la quantità di riga torna
          // il prezzo unitario giusto lo stesso.
          const prezzo = unitario((cart.lines || []).find((x) => String(x.id).startsWith(id + ':')));
          const quantity = Number(l.quantity) || 1;
          if (prezzo !== undefined) valore += prezzo * quantity;
          return { item_id: id, ...schedaDi(id), price: prezzo, quantity };
        });
        dl('add_to_cart', { currency: cart.cost?.totalAmount?.currencyCode || 'EUR', value: valore || undefined, items });
      }).catch(() => {});
    });

    // T03 · view_cart. Horizon emette già `shopify:cart:view` da sé: `<cart-items-component>`
    // porta `view-event-payload` (cart-items-component.liquid:25) e, nel cassetto,
    // `view-event-trigger="dialog"` (:21), che lo fa scattare all'apertura del dialog. Niente
    // listener sull'apertura, niente /cart.js.
    document.addEventListener(StandardEvents.cartView, e => {
      // T03b (misurato da OP-3 il 15/09, passo 3). Il payload di questo evento lo rende Liquid al
      // CARICO della pagina: dopo un'aggiunta che apre il cassetto da sola arriva con `lines: []` e
      // totale null, cioè il carrello com'era PRIMA. Nel percorso più comune — aggiungo, guardo il
      // cassetto — non usciva nessun view_cart. Quindi l'ordine delle fonti è: prima l'ultimo
      // carrello visto da cartLinesUpdate (il più fresco), poi quello dell'evento, poi le righe.
      const righe = righeDom(e.context);
      const inMemoria = ultimoCarrello && Array.isArray(ultimoCarrello.lines) ? ultimoCarrello : null;
      // se la memoria dice che il carrello è vuoto, è vuoto: è più recente del payload di Liquid,
      // e senza questo controllo svuotare il cassetto e riaprirlo spingerebbe le righe di prima.
      if (inMemoria && !inMemoria.lines.length) return;
      const carrello = inMemoria?.lines.length ? inMemoria
        : (e.cart && Array.isArray(e.cart.lines) && e.cart.lines.length) ? e.cart
        : null;
      if (!carrello && !righe.length) return;   // carrello vuoto davvero: niente evento

      const items = carrello
        ? carrello.lines.map((l, i) => {
            const id = idVariante(l.id) || idVariante(righe[i]?.dataset.key);
            return { item_id: id, ...schedaDi(id, righe[i]), price: unitario(l), quantity: Number(l.quantity) || 1 };
          })
        // ultimo ripiego: nessun carrello utile, ma le righe in pagina ci sono. Id, nome, formato e
        // quantità dal DOM; il prezzo NO: in pagina è formattato («68,00 €» o «€68,00», il formato
        // valuta è ancora in discussione) e un numero estratto da lì si romperebbe da solo.
        : righe.map((r) => {
            const id = idVariante(r.dataset.key);
            const q = Number((r.querySelector('input[name="updates[]"]') || {}).value);
            return { item_id: id, ...schedaDi(id, r), quantity: q > 0 ? q : 1 };
          });

      const totale = Number(carrello?.cost?.totalAmount?.amount);
      dl('view_cart', {
        currency: carrello?.cost?.totalAmount?.currencyCode || 'EUR',
        value: Number.isFinite(totale) && totale ? totale : undefined,
        items,
      });
    });
  }).catch(() => { /* senza import map il contatore resta quello di /cart.js al caricamento */ });
  header.addEventListener('click', e => {
    const a = e.target.closest('.cart-link');
    if (!a) return;
    const cassetto = document.getElementById('cart-drawer');
    if (!cassetto || typeof cassetto.open !== 'function') return; // niente cassetto: il link porta a /cart
    e.preventDefault();
    chiudiTutti();
    cassetto.open();
  });

  // ---- le altezze per Horizon ----
  function misura() {
    const gruppo = document.getElementById('header-group');
    const radice = header.closest('.shopify-section') || header;
    document.body.style.setProperty('--header-height', `${radice.offsetHeight}px`);
    if (gruppo) {
      let altri = 0;
      for (const el of gruppo.children) if (el !== radice && el instanceof HTMLElement) altri += el.offsetHeight;
      document.body.style.setProperty('--header-group-height', `${altri}px`);
    }
  }
  misura();
  addEventListener('resize', misura);
  addEventListener('load', misura);
})();
